<template>
  <div>
    <div v-if="currentContent === 'listStages'">
      <base-card>
        <base-question text="Este produto possui etapas?" class="mb_20" />
        <base-radio
          label="Não"
          family="stages"
          class="mb_15"
          :value="hasStages"
          :option="false"
          @click="hasStages = false"
        />
        <base-radio
          label="Sim"
          family="stages"
          :value="hasStages"
          :option="true"
          @click="hasStages = true"
        />
      </base-card>
      <base-card v-if="hasStages">
        <base-question
          :text="`Configure as etapas deste produto (${targetItem.items.length})`"
          class="mb_20"
        />
        <div v-if="targetItem.items.length > 0">
          <div
            v-for="(step, stepIndex) in targetItem.items.filter(
              (i) => !i.delete
            )"
            :key="step._id"
          >
            <div class="stages-container">
              <base-box sortBox class="size-box">
                <div class="stage-container">
                  <p>{{ step.name }}</p>
                  <div v-if="sortMode.step">
                    <i
                      v-show="stepIndex < targetItem.items.length - 1"
                      class="fal fa-chevron-down sort-icon"
                      @click="moveItem(step, stepIndex, false)"
                    ></i>
                    <i
                      v-show="stepIndex > 0"
                      class="fal fa-chevron-up ml_20 sort-icon"
                      @click="moveItem(step, stepIndex, true)"
                    ></i>
                  </div>
                </div>
              </base-box>
              <base-button
                design="four"
                @click.prevent="editStep(step)"
                class="stage-button mr_15"
              >
                <i class="fal fa-pen"></i>
              </base-button>
              <base-button
                design="four"
                @click.prevent="deleteStep(step._id)"
                class="stage-button"
              >
                <i class="fal fa-times"></i>
              </base-button>
            </div>
          </div>
        </div>
        <div class="buttons-container">
          <div :class="sortMode.step ? 'd-flex w-100' : ''">
            <base-button
              v-if="targetItem.items.length > 0"
              :text="sortMode.step ? StringLanguage.saveSort : ''"
              class="sort-stages mr_15"
              :class="sortMode.step ? 'w-100' : ''"
              design="two"
              @click.prevent="sortMode.step = !sortMode.step"
            >
              <i v-if="!sortMode.step" class="fal fa-sort-size-up"></i>
            </base-button>
          </div>
          <div v-if="!sortMode.step" class="d-flex justify-end w-100">
            <base-button
              text="Adicionar etapa"
              design="two"
              @click.prevent="openAddStageContent()"
              class="w-100"
            />
          </div>
        </div>
      </base-card>
    </div>
    <div v-else class="add-stage-content">
      <base-card>
        <base-question text="Pergunta" class="mb_20" />
        <base-input
          class="stage-item"
          :placeholder="StringLanguage.question"
          v-model="question.name"
          :valid="isValidField('main', 'name')"
        />
      </base-card>

      <base-card>
        <base-question text="Respostas" class="mb_20" />
        <div v-if="question && (textAnswers || editMode.status)">
          <div
            v-for="(answer, i) in question.items.filter((i) => !i.delete)"
            :key="i"
            class="stage-row"
          >
            <base-input
              placeholder="Ex: Pão de forma"
              class="stage-item mb_0 pt_0 mr_15"
              v-model="answer.name"
              :valid="isValidField()"
            />

            <base-input
              :label="StringLanguage.value"
              :money-mask="StringLanguage.currencyConfigs"
              v-model="answer.price"
              class="stage-item--small mb_0 pt_0 mr_15"
            />

            <base-button
              :text="StringLanguage.delete"
              design="four"
              @click.prevent="
                question.items.filter((i) => !i.delete).length === 1
                  ? clearTextAnswer(answer)
                  : (answer.delete = true)
              "
              class="stage-button"
            >
              <i class="fal fa-times"></i>
            </base-button>
          </div>
        </div>
        <div v-if="productAnswers && question && !editMode.status">
          <base-message
            v-if="
              !hideMessageBox ||
              question.items.filter((i) => !i.delete).length === 0
            "
            class="gold"
          >
            <span>
              Este método simplesmente copia o nome dos produtos para as
              respostas, desta forma não há vinculo nenhum entre os dois
              elementos. Logo, caso hajam alterações no produto copiado, será
              necessário replicar essas alterações aqui.
            </span>
          </base-message>
          <div
            v-if="
              question.items.filter((i) => !i.delete).length === 0 &&
              copyCategory.enabled.hasOwnProperty(question._id) &&
              categories
            "
            class="stage-row mt_20 mb_25"
          >
            <base-select
              :title="StringLanguage.selectCategory"
              :placeholder="StringLanguage.selectCategory"
              class="stage-item mb_0 mt_0 mr_15"
              @change="
                selectCopyCategory(question._id, arguments[0].target.value)
              "
            >
              <option
                v-for="category in categories"
                :value="category._id"
                :key="category._id"
              >
                {{ category.name }}
              </option>
            </base-select>

            <base-button
              :text="StringLanguage.delete"
              design="four"
              @click.prevent="productAnswers = false"
              class="stage-button mb_0 mt_10"
            >
              <i class="fal fa-times"></i>
            </base-button>
          </div>

          <div v-if="question.items.filter((i) => !i.delete).length > 0">
            <div
              v-for="answer in question.items.filter((i) => !i.delete)"
              :key="answer._id"
            >
              <div class="stage-row mb_25">
                <base-input
                  placeholder="Ex: Pão de forma"
                  class="stage-item mb_0 pt_0 mr_15"
                  v-model="answer.name"
                  :valid="isValidField()"
                />

                <base-input
                  :label="StringLanguage.value"
                  v-model="answer.price"
                  :money-mask="StringLanguage.currencyConfigs"
                  class="stage-item--small mb_0 pt_0 mr_15"
                />

                <base-button
                  :text="StringLanguage.delete"
                  design="four"
                  @click.prevent="answer.delete = true"
                  class="stage-button"
                >
                  <i class="fal fa-times"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="stage-row">
          <base-button
            v-if="!productAnswers"
            :text="
              textAnswers || editMode.status
                ? 'Adicionar respostas em texto'
                : 'Respostas em texto'
            "
            design="two"
            class="w-100 mt_5"
            :class="!textAnswers && !editMode.status ? 'mr_15' : ''"
            @click="addOption(question._id)"
          />
          <base-button
            v-if="!textAnswers && !productAnswers && !editMode.status"
            text="Respostas com produtos"
            design="two"
            class="w-100 mt_5"
            @click="enableCopyToStep(question._id)"
          />

          <base-button
            v-if="confirmCopy && productAnswers"
            text="Confirmar"
            design="two"
            class="w-100 mt_5"
            @click="confirmCopyCategory(question._id)"
          />
        </div>
      </base-card>

      <base-card class="last-card">
        <base-question
          text="Quais são as quantidades mínimas e máximas desta etapa?"
          class="mb_20"
        />

        <div class="stage-row">
          <base-input
            :label="StringLanguage.minToSelect"
            class="mb_0 mr_15 stage-item"
            v-model="question.min"
            @change="question.max = Math.max(question.min, question.max)"
          />
          <base-input
            :label="StringLanguage.maxToSelect"
            class="mb_0 stage-item"
            v-model="question.max"
            @change="question.min = Math.min(question.min, question.max)"
          />
        </div>
      </base-card>

      <div class="footer">
        <div class="footer-container">
          <base-button
            design="four"
            class="mr_10 big footer-button"
            @click="cancel()"
          >
            <span>Cancelar</span>
          </base-button>

          <base-button
            v-if="!editMode.status"
            class="ml_5 big footer-button"
            @click="addStep()"
          >
            <span>Criar etapa</span>
          </base-button>

          <base-button
            v-else
            class="ml_5 big footer-button"
            @click="saveStep()"
          >
            <span>Salvar</span>
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import Vue from 'vue';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseInput from '@/components/Input';
import BaseButton from '@/components/Button';
import BaseRadio from '@/components/Radio';
import BaseSelect from '@/components/Select';
import BaseCheckbox from '@/components/Checkbox';
import BaseBox from '@/components/Box';
import BaseMessage from '@/components/Message';
// libs

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseInput,
    BaseButton,
    BaseSelect,
    BaseRadio,
    BaseCheckbox,
    BaseBox,
    BaseMessage,
  },
  data() {
    return {
      hasStages: this.targetItem.items.length > 0,
      currentContent: 'listStages',
      stage: {},
      textAnswers: false,
      productAnswers: false,
      sortMode: {
        step: false,
      },
      question: null,
      editMode: {
        step: null,
        status: false,
      },
      copyCategory: {
        enabled: {},
      },
      confirmCopy: false,
      hideMessageBox: false,
      errors: {
        main: [],
      },
    };
  },
  props: {
    targetItem: { default: {} },
    originCatalog: { default: {} },
    changeFooter: { type: Function },
  },
  updated() {
    console.log(this.errors);
  },
  methods: {
    openAddStageContent() {
      this.question = this.initNewItem('Question', this.targetItem._id);
      this.currentContent = 'addStage';
      this.$emit('changeFooter', true);
    },
    editStep(step) {
      this.editMode = {
        step: Builder.mountSchema(JSON.parse(JSON.stringify(step))),
        status: !this.editMode.status,
      };

      this.question = this.editMode.step;

      this.currentContent = 'addStage';
      this.$emit('changeFooter', true);
    },
    cancel() {
      this.editMode = {
        step: null,
        status: false,
      };

      this.currentContent = 'listStages';
      this.$emit('changeFooter', false);
    },
    isValidField(_id, field) {
      // eslint-disable-next-line no-underscore-dangle
      return !this.errors[_id] || this.errors[_id].indexOf(field) === -1;
    },
    highlightErrorFields() {
      this.errors = { main: [] };

      if (!this.question.name || this.question.name === '') {
        this.errors.main = [...(this.errors.main || []), 'name'];
      }
    },
    deleteStep(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem.getItemsByParam('_id', id).forEach((i) => {
            Vue.set(i, 'delete', true);
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, (res) => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit('saveItem', this.targetItem);
      }
    },
    initNewItem(type, target, node) {
      const item =
        type === 'Option' && !this.editMode.status
          ? (node || this.question).getItemsByParam('_id', target)[0]
          : (node || this.targetItem).getItemsByParam('_id', target)[0];
      const newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId('_');

      if (newItem.type == 'question') {
        newItem.min = 0;
      }

      newItem.parent = item._id;
      if (type === 'Option') item.addItems(newItem);

      return newItem;
    },
    saveStep() {
      if (this.question) {
        if (parseInt(this.question.max) === 0) {
          alert('A quantidade máxima não pode ser 0');
          return false;
        }

        if (!this.question.name || this.question.name === '') {
          this.highlightErrorFields();
          alert('A pergunta não pode ser vazia');
          return false;
        }

        this.targetItem.items.forEach((question) => {
          if (question._id === this.question._id)
            Object.assign(question, this.question);
        });
      }

      this.question = null;
      this.editMode = {
        step: null,
        status: false,
      };

      this.currentContent = 'listStages';
      this.$emit('changeFooter', false);
      return true;
    },
    addStep() {
      if (this.question) {
        if (parseInt(this.question.max) === 0) {
          alert('A quantidade máxima não pode ser 0');
          return false;
        }

        if (!this.question.name || this.question.name === '') {
          this.highlightErrorFields();
          alert('A pergunta não pode ser vazia');
          return false;
        }

        this.targetItem.addItems(this.question);
      }

      this.currentContent = 'listStages';
      this.$emit('changeFooter', false);
      this.question = null;
      return true;
    },
    addOption(id) {
      if (this.editMode.status) {
        const newItem = Builder.factory('Option');
        newItem.new = true;
        newItem._id = Builder.generateRandomId('_');
        newItem.parent = this.editMode.step._id;

        this.editMode.step.addItems(newItem);

        return;
      }

      if (!this.productAnswers) this.textAnswers = true;
      if (!this.textAnswers) this.productAnswers = true;

      return this.initNewItem('Option', id);
    },
    saveOptions() {
      const updatedStep = this.targetItem.getItemsByParam(
        '_id',
        this.editMode.step._id
      )[0];

      if (updatedStep) {
        updatedStep.items = [...this.editMode.step.items];
        this.editMode.status = false;
      }
    },
    setChangeToItem(item) {
      switch (item.type) {
        case 'option':
          item.changed = true;
          item.parent_ref.changed = true;
          item.parent_ref.parent_ref.changed = true;
          break;
        case 'question':
          item.changed = true;
          item.parent_ref.changed = true;
          break;
        case 'step':
          item.changed = true;
          break;
      }
    },
    moveItem(item, currentIndex, up) {
      const itemParent = item.parent_ref;
      const newIndex = currentIndex + (up ? -1 : 1);
      if (newIndex < 0 || newIndex >= itemParent.length) {
        return false;
      }
      itemParent.items.splice(
        newIndex,
        0,
        itemParent.items.splice(currentIndex, 1)[0]
      );
      itemParent.items.forEach((item, index) => {
        item.position = index;
        this.setChangeToItem(item);
      });
      this.$forceUpdate();
    },
    enableCopyToStep(step_id) {
      this.productAnswers = true;
      this.hideMessageBox = false;
      this.copyCategory.enabled = {
        ...this.copyCategory.enabled,
        [step_id]: null,
      };
    },
    addCopyOption(id) {
      if (this.copyCategory.enabled[id] && this.question) {
        if (this.question) {
          const option = Builder.factory('Option');
          option.new = true;
          option._id = Builder.generateRandomId('_');

          option.parent = this.question._id;
          this.question.addItems(option);

          return option;
        }
      }
    },
    selectCopyCategory(step_id, category_id) {
      const categories = this.originCatalog.getItemsByParam('_id', category_id);
      this.copyCategory.enabled[step_id] =
        categories.length > 0 ? categories[0] : null;

      if (!this.copyCategory.enabled[step_id]) {
        return false;
      }

      this.confirmCopy = true;
      this.hideMessageBox = false;

      return true;
    },
    confirmCopyCategory(step_id) {
      const category = this.copyCategory.enabled[step_id];
      const { items } = category;
      this.question.items = [];

      new Set(items.map((i) => i.name)).forEach((name) => {
        const option = this.addCopyOption(step_id);
        option.name = name;
      });

      this.confirmCopy = false;
      this.hideMessageBox = true;
    },
    cancelCopyCategoryNames(step_id) {
      if (!this.copyCategory.enabled.hasOwnProperty(step_id)) {
        return false;
      }

      delete this.copyCategory.enabled[step_id];
      Vue.set(this.copyCategory, 'enabled', this.copyCategory.enabled);
      this.$forceUpdate();
      return true;
    },
    clearTextAnswer(answer) {
      answer.delete = true;
      this.textAnswers = false;
    },
  },
  computed: {
    categories() {
      const categories = this.originCatalog
        ? this.originCatalog.getItemsByParam('type', 'category')
        : [];
      return categories.length > 0 ? categories : null;
    },
  },
  watch: {
    currentContent(newValue) {
      if (newValue === 'listStages') {
        this.textAnswers = false;
        this.productAnswers = false;
        this.question = null;
      }
    },
    productAnswers(newValue) {
      if (newValue === false && this.question) this.question.items = [];
    },
  },
};
</script>

<style scoped>
.stages-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}
.stage-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.size-box {
  flex: 1;
  display: flex;
  align-items: center;
  max-height: 45px;
  margin-right: 15px;
}
.size-box p {
  color: #aaaaaacc;
  font-size: 1.2em;
}
.stage-button {
  height: 45px;
  border-color: #99999980;
}
.stage-button i {
  font-size: 12px;
}
.stage-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.stage-item {
  flex: 1;
  margin-bottom: 0;
}
.stage-item--small {
  flex: 0.5;
  margin-bottom: 0;
}
.add-stage-content {
  min-height: 100%;
}
.footer {
  background: var(--box);
  width: calc(100% + 30px);
  box-shadow: 0px 0px 6px #00000029;
  padding: 20px 15px;
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: -15px;
}
.footer-container {
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.footer-button {
  flex: 1;
}
.checkbox-area {
  color: #999999;
  font-size: 12px;
}
.buttons-container {
  display: flex;
  align-items: center;
}
.sort-stages {
  height: 35px;
}
.sort-stages i {
  font-size: 14px;
}
.last-card {
  padding-bottom: 100px !important;
}
.sort-icon {
  cursor: pointer;
  transition: transform linear 0.15s;
}
.sort-icon:hover {
  transform: scale(1.2);
}
</style>
